import { useNavigate } from 'react-router-dom'
import { ArenaCarouselComponent } from '../../types/sdui'
import { ArenaSection } from '../ArenaSection'
import { Arena } from '../../types/arena'
import { useComponentImpression, analyticsService } from '@meiuca/analytics'

interface ArenaCarouselProps {
  config: ArenaCarouselComponent
}

export function ArenaCarousel({ config }: ArenaCarouselProps) {
  const navigate = useNavigate()

  // Track component impression
  const impressionRef = useComponentImpression({
    componentType: 'arena_carousel',
    componentKey: config.id
  })

  // Converter ArenaItem para Arena (formato esperado pelo ArenaSection)
  const arenas: Arena[] = config.arenas.map((item) => ({
    id: item.id,
    slug: item.slug,
    name: item.name,
    coverImage: item.coverImage ?? '',
    location: item.location,
    distance: item.distance ?? 0,
    rating: item.rating,
    reviewCount: item.reviewCount,
    modalities: item.modalities as any[], // Cast temporário - idealmente seria um enum
    address: '' // Não usado no card, mas required na interface
  }))

  const handleArenaClick = (arena: Arena) => {
    // Track arena click
    analyticsService.track('arena_carousel_card_clicked', {
      arena_id: arena.id,
      arena_name: arena.name,
      component_id: config.id,
      component_type: 'arena_carousel'
    })

    navigate(`/arena/${arena.slug ?? arena.id}`)
  }

  const handleSeeMore = config.ctaLink
    ? () => {
        // Track see more click
        analyticsService.track('arena_carousel_see_more_clicked', {
          component_id: config.id,
          component_type: 'arena_carousel',
          target_url: config.ctaLink
        })

        navigate(config.ctaLink!)
      }
    : undefined

  return (
    <div ref={impressionRef} className="max-w-7xl mx-auto px-4 py-6">
      <ArenaSection
        title={config.title}
        arenas={arenas}
        onSeeMore={handleSeeMore}
        onArenaClick={handleArenaClick}
      />
    </div>
  )
}
